webpackJsonp([89842151690323],{

/***/ 1089:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"Link","methods":[],"props":{"disabled":{"type":{"name":"bool"},"required":false,"description":"Disable or enable button.","defaultValue":{"value":"false","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"CSS Class to apply to button.","defaultValue":{"value":"''","computed":false}},"style":{"type":{"name":"objectOf","value":{"name":"any"}},"required":false,"description":"Css style applied to the component","defaultValue":{"value":"null","computed":false}},"tooltip":{"type":{"name":"string"},"required":false,"description":"Button tooltip.","defaultValue":{"value":"''","computed":false}},"href":{"type":{"name":"string"},"required":true,"description":"Link to open."},"target":{"type":{"name":"string"},"required":false,"description":"Target of link.","defaultValue":{"value":"''","computed":false}},"children":{"type":{"name":"union","value":[{"name":"arrayOf","value":{"name":"node"}},{"name":"node"}]},"required":false,"description":"Elements to show inside of Links","defaultValue":{"value":"null","computed":false}}},"filename":"/components/Link/Link.jsx"}

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _link = __webpack_require__(520);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _map = __webpack_require__(1089);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _link2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _link2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/Link',
	        description: _link2.default.summary,
	        stories: _link2.default.stories,
	        importCode: _link2.default.import,
	        withStyles: _link2.default.withStyles,
	        extractProps: _link2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  name: 'Link',
	  summary: 'Link are hyperlink. You can click on a link and jump to another document. When you move the mouse over a link, the mouse arrow will turn into a little hand.',
	  import: '',
	  withStyles: true,
	  stories: [{
	    name: 'Basic',
	    summary: '',
	    code: '<Link href="https://front10.com" tooltip="This is a tooltip" target="_blank">This is a link</Link>',
	    tabsActive: ['code']
	  }, {
	    name: 'Disabled',
	    summary: '',
	    code: '<Link disabled href="https://front10.com">This is disabled</Link>',
	    tabsActive: []
	  }, {
	    name: 'With icon',
	    summary: '',
	    code: '<Link href="https://front10.com" tooltip="This is a tooltip" target="_blank">\n    <Icon icon="fa fa-home" />\n    <span>This is disabled</span>\n</Link>',
	    tabsActive: []
	  }, {
	    name: 'Like a button',
	    summary: '',
	    code: '<>\n    <Link className="btn btn-primary mr-1" href="https://github.com/front10/landing-page-book" tooltip="This is a tooltip" target="_blank">\n        <Icon icon="fa fa-github" /> View code on Github\n    </Link>\n    <Link className="btn btn-outline-success mr-1" href="https://front10.com/#contactForm" tooltip="Contact us" target="_blank">\n        <Icon icon="fa fa-info-circle" /> Contact us\n    </Link>\n</>',
	    tabsActive: []
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-link-js-906f2681eb958a22483f.js